import { NavigateFunction } from 'react-router-dom';

import { TAB_ITEM_LIST, TAB_ITEM_INDEX_0 } from '../types/common/CommonType';

export const tabNavigation = (
    clickIndex: number,
    searchResltLength: number,
    navigation: NavigateFunction,
    setTabIndex: (value: number) => void
) => {
    // タブ情報を取得
    const tabInfo = TAB_ITEM_LIST.find((tabItem) => tabItem.tabIndex === clickIndex);
    if (!tabInfo) {
        return;
    }
    setTabIndex(clickIndex);
    let movePath = '';
    if (clickIndex === TAB_ITEM_INDEX_0) {
        movePath = searchResltLength > 0 ? '/searchResult' : '/';
    } else {
        movePath = tabInfo.navigation;
    }
    if (clickIndex === tabInfo.tabIndex && location.pathname !== tabInfo.navigation) {
        navigation(movePath);
    }
};
